import { Modal, ScrollArea } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { ReactNode } from 'react';
import './styles.scss';

interface ModalComponentProps {
  show: boolean;
  handleClick: () => void;
  title?: ReactNode;
  content: ReactNode;
  classname?: string;
}

const ModalComponent: React.FC<ModalComponentProps> = ({ show, handleClick, title, content, classname }) => {
  const isMobile = useMediaQuery('(max-width: 575px)');

  return (
    <Modal
      opened={show}
      onClose={handleClick}
      title={title || ''}
      centered
      fullScreen={isMobile}
      withCloseButton={!!title}
      size="auto"
      className={classname}
      styles={{
        content: { maxHeight: '90vh', width: isMobile ? '100vw' : 'auto' },
        body: {
          padding: '1.5rem'
        }
      }}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      {content}
    </Modal>
  );
};

export default ModalComponent;
